module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "crop-wrap",
    on: {
      "mousedown": _vm.wrapMouseDown
    }
  }, [_c('div', {
    staticClass: "shadow-box",
    style: (_vm.recStyle)
  }, [_c('img', {
    staticClass: "shadow-img",
    style: (_vm.imgStyle),
    attrs: {
      "src": _vm.img
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "crop-box",
    class: _vm.showBox ? 'show' : '',
    style: (_vm.recStyle),
    on: {
      "mousedown": _vm.boxMouseDown
    }
  }, [_c('span', {
    staticClass: "drag-point point-lt",
    on: {
      "mousedown": function($event) {
        _vm.pointMouseDown('drag-lt', $event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "drag-point point-lb",
    on: {
      "mousedown": function($event) {
        _vm.pointMouseDown('drag-lb', $event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "drag-point point-rt",
    on: {
      "mousedown": function($event) {
        _vm.pointMouseDown('drag-rt', $event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "drag-point point-rb",
    on: {
      "mousedown": function($event) {
        _vm.pointMouseDown('drag-rb', $event)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73993fae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectBox.vue
// module id = 14
// module chunks = 0